import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const embeddedFormPaths = new Set(['/webinar-mc', '/webinar-mc-b', '/webinar-mc-mail', '/webinar-mc-adv1', '/webinar-mc-adv2', '/webinar-mc-adv4-pmax', '/webinar-mc-adv5', '/webinar-mc-search-blaffen', '/webinar-mc-search-puppy', '/webinar-mc-search-hondentaal-lichaamstaal', '/webinar-mc-stem-gsearch', '/webinar-mc-stem-meta', '/verlatingsangst-webinar', '/blog/onzekere-hond-spl1']);
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    if (window.fbq && window.fbq.loaded) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1596463344592597');
    window.fbq('init', '529688670924351');
    window.fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    if (embeddedFormPaths.has(pathname)) {
      window.fbq('track', 'ViewContent');
    }
  }, [pathname]);
  return null;
}